import {useEffect, useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import axios from 'axios'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
  showToastMessageSuccess,
  showToastMessageError,
  showToastMessageWarning,
} from '../../modules/Toast-Message/TosatMessage'
import CurrencyFormat from 'react-currency-format'
import {CSVLink} from 'react-csv'
// import DataTable from 'react-data-table-component';
import Detail from './Detail'
import {DataTable} from 'primereact/datatable'
import {Column} from 'primereact/column'
import { Button } from 'primereact/button';
import { DataView } from 'primereact/dataview';
import { Card } from 'primereact/card';
import MobileUse from '../../modules/mobileUtilities/MobileUse'
import './commitmentstyle.css'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import {Calendar} from 'primereact/calendar'
import './filterbutton.css'
import {AddTracking} from './AddTracking'
import {Dropdown} from 'primereact/dropdown'
import {statusFilterOptions, daysFilterOptions} from './StaticData'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  return JSON.parse(data)
}

const MyCommitments = () => {
  const [commitData, setCommitData] = useState([])
  const [editId, setEditId] = useState(null)
  const [updatedQty, setUpdatedQty] = useState('')
  const [errorMsg, setErrorMsg] = useState('')
  const [loading, setLoading] = useState(false)
  const [searchCommitID, setSearchCommitID] = useState('')
  const [searchDealID, setSearchDealID] = useState('')
  const [searchItemName, setSearchItemName] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  const [searchQuery, setSearchQuery] = useState('')
  const [searchSelect, setSearchSelect] = useState('ITEM_NAME')

  const [showDetailModal, setShowDetailModal] = useState(false)
  const [modalDetailContent, setModalDetailContent] = useState({})

  const [showCreateAppModalTracking, setShowCreateAppModalTracking] = useState(false)
  const [propsData, setPropsData] = useState([])

  const API_URL = process.env.REACT_APP_API_URL
  const GET_COMMIT_URL = `${API_URL}/my-commitments`
  const UPDATE_COMMIT_URL = `${API_URL}/commit-update`
  const apiToken = getLocalData().api_token

  const isMobileDevice = MobileUse();
  const data = commitData

  const paginatorLeft = <Button type='button' icon='pi pi-refresh' text />
  const paginatorRight = <Button type='button' icon='pi pi-download' text />

  

  const [isOpen, setIsOpen] = useState(false)
  const [showHeader, setShowHeader] = useState(true)
  const [toggleFilter, setToggleFilter] = useState('NONE')
  const [filterOpen, setFilterOpen] = useState(false)

  const [statusFilter, setStatusFilter] = useState(1)
  const [daysFilter, setDaysFilter] = useState('15')

  const toggleMenu = () => {
    setIsOpen(!isOpen)
    if (isOpen) {
      setToggleFilter('NONE')
    }
  }

  const handleButtonClick = () => {
    console.log('floating button clicked')
  }

  const openFilterBox = () => {
    setFilterOpen(true)
  }

  const closeFilterBox = () => {
    setFilterOpen(false)
  }

  const getCommitments = async (statusFilterData, daysFilterData) => {
    setLoading(true)
    // const config = {
    //   headers: { Authorization: `Bearer ${apiToken}` }
    // };
    await axios
      .get(GET_COMMIT_URL, {
        headers: {Authorization: `Bearer ${apiToken}`},
        params: {
          // searchCommitID: searchCommitID,
          // searchDealID: searchDealID,
          // searchItemName: searchItemName,
          // startDate: startDate,
          // endDate: endDate,
          status_filter: statusFilterData,
          days_filter: daysFilterData,
        },
      })
      .then((response) => {
        setCommitData(response.data.data)
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }

  const updateCommitment = async () => {
    if (editId) {
      if (!updatedQty) {
        setErrorMsg('enter commit quantity')
      } else {
        await axios
          .put(`${UPDATE_COMMIT_URL}/${editId}`, {
            commited_qty: updatedQty,
          })
          .then((response) => {
            setEditId(null)
            getCommitments(statusFilter, daysFilter)
            showToastMessageSuccess(response.data.message)
            setErrorMsg('')
          })
          .catch((error) => {
            console.error(error)
            if (error.response && error.response.data) {
              console.log(error.response.data)
              const errorResponse = error.response.data
              if (errorResponse.data) {
                const fieldErrors = errorResponse.message
                showToastMessageError(fieldErrors)
              }
            } else {
              showToastMessageError('An error occurred.')
            }
            setErrorMsg('')
          })
      }
    }
  }

  const startDateObject = new Date(startDate)
  const endDateObject = new Date(endDate)

  const handleSingleSearch = (value) => {
    setSearchQuery(value)
    setSearchCommitID(value)
    setSearchDealID(value)
    setSearchItemName(value)
  }

  const handleFilter = () => {
    if (startDate !== '' && endDate !== '') {
      const filteredItems = data.filter(
        (item) =>
          item.commitment_no.toLowerCase().includes(searchCommitID.toLowerCase()) &&
          item.deal_no.toLowerCase().includes(searchDealID.toLowerCase()) &&
          item.deal_name.toLowerCase().includes(searchItemName.toLowerCase()) &&
          new Date(item.date) >= startDateObject &&
          new Date(item.date) <= endDateObject
      )
      return filteredItems
    } else {
      const filteredItems = data.filter(
        (item) =>
          item.commitment_no?.toLowerCase().includes(searchCommitID.toLowerCase()) ||
          item.deal_no?.toLowerCase().includes(searchDealID.toLowerCase()) ||
          item.deal_name?.toLowerCase().includes(searchItemName.toLowerCase())
      )
      return filteredItems
    }
  }

  const cancleSearch = () => {
    setSearchCommitID('')
    setSearchDealID('')
    setSearchItemName('')
    setStartDate('')
    setEndDate('')
    setSearchQuery('')
  }

  useEffect(() => {
    getCommitments(statusFilter, daysFilter)
  }, [])

  useEffect(() => {
    handleFilter()
  }, [commitData])

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value
    setStatusFilter(selectedStatus)
    getCommitments(selectedStatus, daysFilter)
  }
  const handleDaysChange = (e) => {
    const selectedDays = e.target.value
    setDaysFilter(selectedDays)
    getCommitments(statusFilter, selectedDays)
  }

  const DealDetail = ({dealname, dealno, dealimage, dealsku, dealprice, dealstatus, fulfilled}) => {
    return (
      <>
        <a href='#'>{dealname}</a>
        {showDetailModal && <Detail content={modalDetailContent} onClose={closeModal} />}
      </>
    )
  }

  const openModal = (item) => {
    const content = {
      deal_no: item.deal_no,
      deal_image: item.deal_image,
      deal_name: item.deal_name,
      deal_sku: item.sku,
      deal_price: item.price,
      deal_commission: item.commission,
      deal_status: item.status,
      fulfilled: item.fullfill_qty,
    }
    setModalDetailContent(content)
    setShowDetailModal(true)
  }

  const closeModal = () => {
    setShowDetailModal(false)
  }

  const OpenTrackingModal = (item) => {
    setShowCreateAppModalTracking(true)
    setPropsData(item)
  }

  const CloseTrackingModal = () => {
    setShowCreateAppModalTracking(false)
  }

  const statusCondition = (val) => {
    var statusText = ''
    if (val == 0) {
      statusText = 'Received'
    } else if (val == 1) {
      statusText = 'Pending'
    } else if (val == 2) {
      statusText = 'Active'
    } else if (val == 3) {
      statusText = 'Expired'
    } else if (val == 4) {
      statusText = 'In prpgress'
    } else if (val == 5) {
      statusText = 'Return Pending'
    } else if (val == 6) {
      statusText = 'Return Active'
    } else if (val == 7) {
      statusText = 'Return Completed'
    }
    return statusText
  }

  const csvData = [
    [
      'Commitment ID',
      'Deal ID',
      'Item Description',
      'Status',
      'Count',
      'FulFilled',
      'Price',
      'Commission',
      'Total',
      'Created',
    ],
    ...handleFilter().map(
      ({
        commitment_no,
        deal_no,
        deal_name,
        status,
        commited_qty,
        fullfill_qty,
        price,
        commission,
        total_commision,
        date,
      }) => [
        commitment_no,
        deal_no,
        deal_name,
        statusCondition(status),
        commited_qty,
        // on_track,
        fullfill_qty,
        price,
        commission,
        total_commision,
        date,
      ]
    ),
  ]

  const truncateString = (str) => {
    const maxLength = 30
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + '...'
    } else {
      return str
    }
  }

  const tableCustomStyles = {
    headCells: {
      style: {
        backgroundColor: '#cae4f9',
      },
    },
  }

  const TableHeaderFilters = () => {
    if (toggleFilter == 'SEARCH') {
      return (
        <div className='pb-2 pt-5'>
          <div className='d-flex mb-5'>
            <div className='mx-2 search-filter-wrap'>
              <input
                type='text'
                className='form-control'
                placeholder='Search here...'
                value={searchQuery}
                onChange={(e) => handleSingleSearch(e.target.value)}
              />
            </div>
            {/* <div className='mx-2'>
          <select name="search-select" className='form-control' id="" onChange={(e) => setSearchSelect(e.target.value)}>
            <option value="ITEM_NAME" {...searchSelect == "COMMIT_ID" ? 'selected' : '' }>Item Name</option>
            <option value="COMMIT_ID" {...searchSelect == "COMMIT_ID" ? 'selected' : '' }>Commit ID</option>
            <option value="DEAL_ID" {...searchSelect == "COMMIT_ID" ? 'selected' : '' }>Deal ID</option>
          </select>
          </div> */}
            <div className='mx-2'>
              <button
                onClick={() => cancleSearch()}
                className='btn btn-info'
                disabled={
                  searchCommitID === '' &&
                  searchDealID === '' &&
                  searchItemName === '' &&
                  startDate === '' &&
                  endDate === ''
                }
              >
                <i className='fa-solid fa-xmark fs-3'></i>
              </button>
            </div>
          </div>
        </div>
      )
    }
    if (toggleFilter == 'DATE') {
      return (
        <div className='pb-2 pt-5'>
          <div className='d-flex mb-5'>
            <div className='mx-2  calendar-filter-wrap'>
              <label
                className='form-label position-absolute text-gray-600'
                style={{marginTop: '-18px'}}
              >
                Start Date
              </label>
              <input
                type='date'
                className='form-control'
                placeholder='DD-MM-YYYY'
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className='mx-2 calendar-filter-wrap'>
              <label
                className='form-label position-absolute text-gray-600'
                style={{marginTop: '-18px'}}
              >
                End Date
              </label>
              <input
                type='date'
                className='form-control'
                placeholder='DD-MM-YYYY'
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className='mx-2'>
              <button
                onClick={() => cancleSearch()}
                className='btn btn-infor'
                disabled={
                  searchCommitID === '' &&
                  searchDealID === '' &&
                  searchItemName === '' &&
                  startDate === '' &&
                  endDate === ''
                }
              >
                <i className='fa-solid fa-xmark fs-3'></i>
              </button>
            </div>
          </div>
        </div>
      )
    }
    if (toggleFilter == 'EXPORT') {
      return (
        <div className='pb-2 pt-5'>
          <div className='d-flex align-items-center mb-5'>
            <h5>Export CSV for Commitments</h5>
            <div className='mx-2'>
              <button className='btn btn-success text-dark'>
                <CSVLink
                  className='downloadbtn'
                  filename='my-commitments.csv'
                  data={csvData}
                  style={{color: '#fff'}}
                >
                  Export
                </CSVLink>
              </button>
            </div>
          </div>
        </div>
      )
    }
    if (toggleFilter == 'NONE') {
      return false
    }
    if (toggleFilter == 'ALL') {
      return (
        <div className='pb-2 pt-5'>
          <div className='d-flex mb-5'>
            <div className='mx-2'>
              <input
                type='text'
                className='form-control'
                placeholder='Search by Commit ID'
                value={searchCommitID}
                onChange={(e) => setSearchCommitID(e.target.value)}
              />
            </div>
            <div className='mx-2'>
              <input
                type='text'
                className='form-control'
                placeholder='Search by Deal ID'
                value={searchDealID}
                onChange={(e) => setSearchDealID(e.target.value)}
              />
            </div>
            <div className='mx-2'>
              <input
                type='text'
                className='form-control'
                placeholder='Search by Item name'
                value={searchItemName}
                onChange={(e) => setSearchItemName(e.target.value)}
              />
            </div>
            <div className='mx-2'>
              <label
                className='form-label position-absolute text-gray-600'
                style={{marginTop: '-18px'}}
              >
                Start Date
              </label>
              <input
                type='date'
                className='form-control'
                placeholder='DD-MM-YYYY'
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className='mx-2'>
              <label
                className='form-label position-absolute text-gray-600'
                style={{marginTop: '-18px'}}
              >
                End Date
              </label>
              <input
                type='date'
                className='form-control'
                placeholder='DD-MM-YYYY'
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            <div className='mx-2'>
              <button
                onClick={() => cancleSearch()}
                className='btn btn-info'
                disabled={
                  searchCommitID === '' &&
                  searchDealID === '' &&
                  searchItemName === '' &&
                  startDate === '' &&
                  endDate === ''
                }
              >
                <i className='fa-solid fa-xmark fs-3'></i>
              </button>
            </div>
            <div>
              <button className='btn btn-success text-dark'>
                <CSVLink
                  className='downloadbtn'
                  filename='my-commitments.csv'
                  data={csvData}
                  style={{color: '#fff'}}
                >
                  Export
                </CSVLink>
              </button>
            </div>
          </div>
        </div>
      )
    }
  }

  const tableHeader = () => {
    return (
      <div className=''>
        <div class="row">
          <div className="col-lg-4 col-md-12">
            <h4 style={{marginTop: '10px'}}>My Commitments</h4>
          </div>
          <div className="col-lg-8 col-md-12 d-lg-flex align-items-center justify-content-end">
            <div className='d-flex gap-3 align-items-center my-3'>
              <select
                id='statusFilter'
                className='form-select form-select-sm'
                value={statusFilter}
                onChange={handleStatusChange}
                style={{width:120}}
              >
                <option value='1'>Pending</option>
                <option value='0'>Completed</option>
                <option value='3'>Expired</option>
                <option value='All'>All</option>
              </select>
              <select
                id='daysFilter'
                className='form-select form-select-sm'
                value={daysFilter}
                onChange={handleDaysChange}
                style={{width:120}}
              >
                <option value='15'>15 Days</option>
                <option value='30'>30 Days</option>
                <option value='90'>3 Months</option>
                <option value='365'>365 Days</option>
                <option value='All'>All Data</option>
              </select>
            </div>

            

          {/* </div> */}
          <div className="filters-wrap ms-lg-2">

            {toggleFilter === 'SEARCH' && (
              <div class="input-group">
                    <input
                      type='text'
                      className='form-control form-control-sm'
                      style={{width:225,borderTopRightRadius:0,borderBottomRightRadius:0}}
                      placeholder='Search here...'
                      value={searchQuery}
                      onChange={(e) => handleSingleSearch(e.target.value)}
                    />
                <button
                    onClick={() => cancleSearch()}
                    className='btn btn-sm btn-secondary'
                    disabled={
                      searchCommitID === '' &&
                      searchDealID === '' &&
                      searchItemName === '' &&
                      startDate === '' &&
                      endDate === ''
                    }
                  >
                    <i className='fa-solid fa-xmark fs-3'></i>
                  </button>
              </div>
            )}

            {toggleFilter === 'DATE' && (
              <div class="input-group">
                {/* <span class="input-group-text">Select Date</span> */}
                <input
                      type='date'
                      className='form-control form-control-sm'
                      style={{width:100}}
                      placeholder='DD-MM-YYYY'
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      
                    />
                    <input
                      type='date'
                      style={{width:100}}
                      className='form-control form-control-sm'
                      placeholder='DD-MM-YYYY'
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      
                    />
                    <button
                      onClick={() => cancleSearch()}
                      className='btn btn-sm btn-secondary'
                      disabled={
                        searchCommitID === '' &&
                        searchDealID === '' &&
                        searchItemName === '' &&
                        startDate === '' &&
                        endDate === ''
                      }
                    >
                      <i className='fa-solid fa-xmark fs-3'></i>
                    </button>
              </div>
            )}
            
            {toggleFilter === 'EXPORT' && (
              <div className=''>
                <div className='d-flex align-items-center'>
                  <div className='mx-2'>
                    <button className='btn btn-sm btn-success text-dark'>
                      <CSVLink
                        className='downloadbtn'
                        filename='my-commitments.csv'
                        data={csvData}
                        style={{color: '#fff'}}
                      >
                        Export CSV
                      </CSVLink>
                    </button>
                  </div>
                </div>
              </div>
            )}
            
          </div>

          </div>
        </div>
        
      </div>
    )
  }

  const dealBody = (item) => {
    return (
      <>
        <div>
          <OverlayTrigger
            key='top'
            placement='top'
            overlay={
              <Tooltip id={`tooltip-top`} style={{maxWidth: '400px'}}>
                {item.deal_name}
              </Tooltip>
            }
          >
            <span className='fs-5 fw-bold'>{truncateString(item.deal_name)}</span>
          </OverlayTrigger>
        </div>
        <div className=''>
          <span className='fs-7 text-gray-500 me-2'>
            Price :&nbsp;&nbsp;
            <CurrencyFormat
              decimalScale={2}
              value={parseFloat(item.price).toFixed(2)}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
            />
          </span>
          <span className='fs-7 text-gray-500 me-2'>
            Comsn :&nbsp;&nbsp;
            <CurrencyFormat
              decimalScale={2}
              value={parseFloat(item.commission).toFixed(2)}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
            />
          </span>
          <br />
          <span className='fs-7 text-gray-500'>
            Total :&nbsp;&nbsp;
            <CurrencyFormat
              decimalScale={2}
              value={parseFloat(item.total_commision || item.price + item.commission).toFixed(2)}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
            />
          </span>
        </div>
      </>
    )
  }

  const dealIdBody = (item) =>{
    return(
      <>
      <span>{item.deal_no}</span><br/>
      <span className='badge badge-light-danger fs-8 px-3 fw-bold'>Expires : {item.deal_expires}</span>
      </>
    )
  }

  const imageBody = (item) => {
    return (
      <div className='card shadow card-rounded py-1 px-3'>
        {/* <img src={'https://erp.makemoneyormiles.com/storage/deals/549418.jpg'} width={75} height={75} className='mt-3 mb-3'  /> */}
        <img src={item.deal_image} width={40} height={40} className='mt-3 mb-3' />
      </div>
    )
  }

  const actionBody = (item) => {
    return (
      <div className='d-flex'>
        <button
          type='button'
          className='btn btn-secondary btn-sm me-2'
          onClick={() => openModal(item)}
        >
          Detail
        </button>
        <button
          onClick={() => OpenTrackingModal(item)}
          type='button'
          className='btn btn-success btn-sm fw-bold me-5'
        >
          Track
        </button>
      </div>
    )
  }

  const statusBody = (item) => {
    if (item.commited_qty == 0) {
      statusText = <span className='badge badge-light-dark fs-8 p-3 fw-bold'>Void</span>
    } else if (item.commited_qty == item.fullfill_qty) {
      statusText = (
        <span className='badge badge-light-success fs-8 p-3 fw-bold success_active'>Completed</span>
      )
    } else {
      if (item.status == 'DEAL_EXPIRED') {
        statusText = <span className='badge badge-light-danger fs-8 p-3 fw-bold'>Deal Expired</span>
      } else {
        var statusText = ''
        if (item.status == 0) {
          statusText = (
            <span className='badge badge-light-light-success fs-8 p-3 fw-bold success_active'>
              Received
            </span>
          )
        } else if (item.status == 1) {
          statusText = <span className='badge badge-light-warning fs-8 p-3 fw-bold'>Pending</span>
        } else if (item.status == 2) {
          statusText = <span className='badge badge-light-info fs-8 p-3 fw-bold'>Active</span>
        } else if (item.status == 3) {
          statusText = <span className='badge badge-light-danger fs-8 p-3 fw-bold'>Expired</span>
        } else if (item.status == 4) {
          statusText = (
            <span className='badge badge-light-warning fs-8 p-3 fw-bold'>In prpgress</span>
          )
        } else if (item.status == 5) {
          statusText = (
            <span className='badge badge-light-warning fs-8 p-3 fw-bold'>Return Pending</span>
          )
        } else if (item.status == 6) {
          statusText = (
            <span className='badge badge-light-info fs-8 p-3 fw-bold'>Return Active</span>
          )
        } else if (item.status == 7) {
          statusText = (
            <span className='badge badge-light-success fs-8 p-3 fw-bold'>Return Completed</span>
          )
        }
      }
    }
    return statusText
  }

  const priceBody = (item) => {
    return (
      <CurrencyFormat
        decimalScale={2}
        value={parseFloat(item.price).toFixed(2)}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
      />
    )
  }
  const commissionBody = (item) => {
    return (
      <CurrencyFormat
        decimalScale={2}
        value={parseFloat(item.commission).toFixed(2)}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
      />
    )
  }
  const totalBody = (item) => {
    return (
      <CurrencyFormat
        decimalScale={2}
        value={parseFloat(item.total_commision || item.price + item.commission).toFixed(2)}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
      />
    )
  }

  const countBody = (item) => {
    if (item.status == 'DEAL_EXPIRED') {
      return <span>{item.commited_qty}</span>
    } else {
      return (
        <>
          {editId !== item.commit_code && (
            <span>
              {item.commited_qty}
              {item.status == 1 && item.editable == 1 && (
                <span className='btn btn-icon btn-bg-light text-hover-primary btn-active-color-primary btn-sm me-1'>
                  <button
                    onClick={() => {
                      setEditId(item.commit_code)
                      setUpdatedQty(item.commited_qty)
                    }}
                    className='btn'
                  >
                    <KTIcon iconName='pencil' className='fs-3' />
                  </button>
                </span>
              )}
            </span>
          )}
          {editId == item.commit_code && (
            <div className='mt-3'>
              {errorMsg && (
                <p
                  className='position-absolute text-danger fs-8 fw-semibold'
                  style={{marginTop: '-12px'}}
                >
                  {errorMsg}
                </p>
              )}
              <input
                type='text'
                className='form-control custom-form-control'
                style={{width:100,paddingTop:10,paddingBottom:10}}
                value={updatedQty}
                onChange={(e) => setUpdatedQty(e.target.value.replace(/[^0-9]/g, ''))}
                placeholder='Enter Commit Qty'
              />
              <button
                onClick={updateCommitment}
                className='btn btn-success btn-sm custom-update-btn'
                style={{marginRight: '10px'}}
              >
                <i className='fa-solid fa-check'></i>
              </button>
              <button
                className='btn btn-danger btn-sm custom-cancle-btn'
                onClick={() => {
                  setEditId(null)
                  setUpdatedQty(null)
                  setErrorMsg('')
                }}
              >
                <i className='fa-solid fa-xmark'></i>
              </button>
            </div>
          )}
        </>
      )
    }
  }

  const columnStyle = {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
    marginLeft: 10,
    marginRight: 10,
    width: '200px',
  }
  const columnStyleDescription = {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
    marginLeft: 10,
    marginRight: 10,
    width: '400px',
  }
  const columnStyleImage = {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
    marginLeft: 10,
    marginRight: 10,
    width: '50px',
  }

  const columnStyleDate = {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
    marginLeft: 10,
    marginRight: 10,
    width: '275px',
  }

  const filterButton = () => {
    return (
      <div className='floating-button-container'>
        {isOpen && (
          <div className={`menu-buttons ${isOpen ? 'show' : ''}`}>
            <button className='sub-button' onClick={() => setToggleFilter('EXPORT')}>
              <i className='fas fa-download'></i>
            </button>
            <button className='sub-button' onClick={() => setToggleFilter('DATE')}>
              <i className='fas fa-calendar-alt'></i>
            </button>
            <button className='sub-button' onClick={() => setToggleFilter('SEARCH')}>
              <i className='fas fa-search'></i>
            </button>
          </div>
        )}
        <button className='main-button' onClick={toggleMenu}>
          {isOpen ? <i className='fas fa-close'></i> : <i className='fas fa-sliders-h'></i>}
        </button>
      </div>
    )
  }

  // const searchFilter = ()=>{
  //   return(
  // <div className="pb-2 pt-5">
  //     <div className='d-flex mb-5'>
  //         <div className='mx-2'>
  //           <input
  //             type='text'
  //             className='form-control'
  //             placeholder='Search Here...'
  //             value={searchCommitID}
  //             onChange={(e) => setSearchCommitID(e.target.value)}
  //           />
  //         </div>

  //         <div className='mx-2'>
  //           <button
  //             onClick={() => cancleSearch()}
  //             className='btn btn-danger'
  //             disabled={searchCommitID === "" && searchDealID === "" && searchItemName === "" && startDate === "" && endDate === ""}
  //           >
  //             <i className="fa-solid fa-xmark fs-3"></i>
  //           </button>
  //         </div>

  //       </div>
  //       </div>
  //   )
  // }

  // const dateFilter = () =>{
  //   return(
  // <div className="pb-2 pt-5">
  //     <div className='d-flex mb-5'>

  //         <div className='mx-2'>
  //           <label className='form-label position-absolute text-gray-600' style={{ marginTop: "-18px" }}>Start Date</label>
  //           <input
  //             type='date'
  //             className='form-control'
  //             placeholder='DD-MM-YYYY'
  //             value={startDate}
  //             onChange={(e) => setStartDate(e.target.value)}
  //           />
  //         </div>
  //         <div className='mx-2'>
  //           <label className='form-label position-absolute text-gray-600' style={{ marginTop: "-18px" }}>End Date</label>
  //           <input
  //             type='date'
  //             className='form-control'
  //             placeholder='DD-MM-YYYY'
  //             value={endDate}
  //             onChange={(e) => setEndDate(e.target.value)}
  //           />
  //         </div>
  //         <div className='mx-2'>
  //           <button
  //             onClick={() => cancleSearch()}
  //             className='btn btn-infor'
  //             disabled={searchCommitID === "" && searchDealID === "" && searchItemName === "" && startDate === "" && endDate === ""}
  //           >
  //             <i className="fa-solid fa-xmark fs-3"></i>
  //           </button>
  //         </div>

  //       </div>
  //       </div>
  //   )
  // }

  // const exportFilter = ()=>{
  //   return(
  //     <div className="pb-2 pt-5">
  //     <div className='d-flex mb-5'>
  //     <div>
  //         <button className='btn btn-success text-dark'>
  //           <CSVLink className="downloadbtn" filename="my-commitments.csv" data={csvData} style={{ color: "#fff" }}>
  //             Export
  //           </CSVLink>
  //         </button>
  //       </div>
  //       </div>
  //       </div>
  //   )
  // }

  const dataViewList = (items)=>{
    return(
      <div className="data-items">
        {
          items.map((item, idx) => (
            <DataViewItem item={item} idx={idx}/>
          ))
        }
      </div>
    )
  }

  const DataViewItem = ({item,idx}) =>{
    return(
      <Card key={idx} className="mb-3" style={{borderBottom:'2px solid yellow'}}>
          {/* <div className="p-d-flex p-ai-center mb-2"></div> */}
          <div className="row">
            <div className="col-3">
              <div class="mb-3">
                <div className='card shadow card-rounded px-3 d-flex align-items-center justify-content-center'>
                  <img src={item.deal_image} style={{width:'80%',height:'auto'}} className='mt-3 mb-3' />
                </div>
                </div>
            </div>
            <div className="col-9">
              <span className='fw-bold fs-5'>{item.commitment_no}</span>
              <h5 className="mb-2 mt-2">{dealBody(item)}</h5>
            </div>
          </div>
          
          {/* <p><strong>Commit ID:</strong> {item.commitment_no} | <strong className='ms-2'>Deal ID:</strong> {item.deal_no}</p> */}
          <p><strong className='ms-2'>Deal :</strong> {item.deal_no} | <strong className='text-danger'>Expires :</strong> <span className='text-danger'>{item.deal_expires}</span></p>
          <p><strong>Quantity:</strong> {countBody(item)} | <strong className='ms-2'>Created:</strong> {item.date}</p>
          <div className="d-flex align-items-center justify-content-between">
            <div>{statusBody(item)}</div>
            <div className="">{actionBody(item)}</div>
          </div>
        </Card>
    )
  }

  return (
    <div className=''>
      <ToastContainer />

      <div className='card card-body shadow px-3 py-5 top-rounded'>
        {!isMobileDevice ? (
        <div className='commitments-table'>
          <DataTable
            value={handleFilter()}
            removableSort
            size='large'
            header={tableHeader}
            emptyMessage='You have no commitments..'
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{minWidth: '60rem', alignItems: 'center', marginLeft: 'auto', fontSize: 15}}
            paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
            scrollable
            scrollHeight='90vh'
            style={{minWidth: '50rem'}}
          >
            <Column body={imageBody} header='Image' style={columnStyleImage}></Column>
            <Column
              body={dealBody}
              header='Item Description'
              style={columnStyleDescription}
            ></Column>

            <Column field='commitment_no' header='Commit ID' sortable style={columnStyle}></Column>
            <Column header='Deal' body={dealIdBody} sortable style={columnStyle}></Column>
            <Column header='Qty' body={countBody} style={columnStyle}></Column>
            <Column header='Action' body={actionBody} style={columnStyle}></Column>
            <Column header='Status' body={statusBody} style={columnStyle}></Column>
            <Column field='date' header='Created' sortable style={columnStyle}></Column>
          </DataTable>
        </div>
        ) : (
          <div className="card">
            <div className="card-header">{tableHeader()}</div>
            <div className="card-body px-0 py-1">
              <div className="mobile-card-container">
            {data.length === 0 ? (
              <p className="p-text-center ms-5">You have no commitments..</p>
            ) : (
              <DataView 
                value={handleFilter()}
                listTemplate={dataViewList}
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 25, 50]}
                paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
              />
            )}
          </div>
            </div>
          </div>
        )}
      </div>
      <div style={{zIndex: 999}}>{filterButton()}</div>
      {showDetailModal && <Detail content={modalDetailContent} onClose={closeModal} />}
      {showCreateAppModalTracking && (
        <AddTracking
          show={showCreateAppModalTracking}
          propsData={propsData}
          handleClose={() => {
            setShowCreateAppModalTracking(false)
          }}
          handleSuccess={() => {
            getCommitments()
          }}
        />
      )}
    </div>
  )
}

export default MyCommitments
